import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MRState {
  edits: Record<string, any>;
}

const initialState: MRState = {
  edits: {},
};

const mrEditsSlice = createSlice({
  name: 'mrEdits',
  initialState,
  reducers: {
    setEdit: (state, action: PayloadAction<{ key: string; value: any }>) => {
      const { key, value } = action.payload;
      state.edits[key] = value;
    },
    setMultipleEdits: (state, action: PayloadAction<Record<string, any>>) => {
      state.edits = { ...state.edits, ...action.payload };
    },
    clearEdits: (state) => {
      state.edits = {};     
    },
    clearEditsByPattern: (state, action: PayloadAction<string>) => {
      const pattern = action.payload;
      const newEdits: Record<string, any> = {};
      
      // Keep only edits that don't contain the pattern
      Object.keys(state.edits).forEach(key => {
        if (!key.includes(pattern)) {
          newEdits[key] = state.edits[key];
        } 
      });      
    
      state.edits = newEdits;
    },
    removeEdit: (state, action: PayloadAction<string>) => {
      delete state.edits[action.payload];
    }
  }
});

export const { setEdit, setMultipleEdits, clearEdits, clearEditsByPattern, removeEdit } = mrEditsSlice.actions;
export default mrEditsSlice.reducer;
